import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { RegenerateMetricsForDaySchema } from "schema"
import z from "zod"

export function useRegenerateMetricsForDayMutation() {
  return useMutation({
    mutationFn: async (data: z.input<typeof RegenerateMetricsForDaySchema>) => {
      await axios.post("/backoffice/bi/regenerate-metrics-for-day", data)
      return { success: true }
    },
  })
}
